import React from 'react';
import { ItemSheetProviderContext, ItemSheetProviderContextProps } from 'contexts/ItemSheet';

export const useItemSheet = () => React.useContext<ItemSheetProviderContextProps>(ItemSheetProviderContext);
